// import { Button, ButtonProps } from 'react-bootstrap';
// import { useOnModelChange } from '../../modules/react-model-ui/hooks/use-on-model-change';
// import { HBusySpinner } from '../busy-spinner/h-busy-spinner';

import React from "react";
import { ReactModel } from "../../react-model/react-model";
import { useOnModelChange } from "../hooks/use-on-model-change";
import { HBusySpinner } from "./h-busy-spinner";
import "./h-button.css"

// injectTypedCSS(
// 	'button-click',
// 	{
// 		'.css_button': {
// 			position: 'relative',
// 			boxShadow: '2px 2px 2px gray',

// 			'&:active': {
// 				left: 1,
// 				top: 1,
// 				boxShadow: 'none',
// 			},
// 		},
// 	},
// 	{ permanent: true }
// );

interface BaseButtonProps {
    /**
     * Control the underlying rendered element directly by passing in a valid
     * component type
     */
    // as?: keyof JSX.IntrinsicElements | undefined;
    /** The disabled state of the button */
    disabled?: boolean | undefined;
    /** Optionally specify an href to render a `<a>` tag styled as a button */
    href?: string | undefined;
    /** Anchor target, when rendering an anchor as a button */
    target?: string | undefined;
    rel?: string | undefined;
}
interface ButtonProps extends BaseButtonProps, React.ComponentPropsWithoutRef<'button'>{
};


export type HButtonProps<T> =  ButtonProps & {
	children?: any;
	model?: ReactModel<T>;
	field_text?: keyof NonNullable<T>;
	// field_color?: keyof T; //TBootstrapColors;
	field_disabled?: keyof NonNullable<T>; //boolean;
	/** If false, keep the busy spinner space */
	field_busy?: keyof NonNullable<T>; //boolean;
	busy?: boolean;
	/** The word "ref" is reserved. We have to use ref2 */
	ref2?: { current: HTMLButtonElement | null | undefined };

	active?: boolean;
	/** use bootstrap style, unless "none" */
    variant?: 'none' | 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light' | 'link' | ({} & String);
    size?: 'sm' | 'lg' | '';
	/** No bootstrap style */
	// default_style?: boolean;
	// /** When button clicked, set the value to this value */
	// set_to_value: any;
	// ref?: { current: any };
	//onChange?:(e:React.ChangeEvent<HTMLInputElement>)=>void,
	onModelChange?: (state: T) => void | ButtonProps;
};

export function HButton<T>({
	onModelChange,
	// default_style,
	ref2,
	model,
	variant,
	field_text,
	size,
	// field_color,
	field_disabled,
	field_busy,
	busy,
	className,
	children,
	...props
}: HButtonProps<T>) {
	if (model) {
		const { state } = model.useModel();
		var text = field_text && (state as any)[field_text];
		// const color2: any = field_color && state[field_color];
		// if (color2 !== undefined) variant = color2;
		var disabled = field_disabled && (state as any)[field_disabled];
		const busy2 = field_busy && (state as any)[field_busy];
		if (busy2 !== undefined) busy = !!busy2;
		const _useOnModelChange = useOnModelChange;
		_useOnModelChange(model, onModelChange, props);
	}

	// const ref2 = useRef();
	if (variant !== 'none') {
		className=(className||'') + ' h_button m-1 btn btn-' + (variant || 'primary');
		if(size){
			className += ' btn-'+size;
		}
		return (
			<button
				{...props}
				//
				ref={ref2 as any}
				// data-model-id={model?.model_id.toString()}
				disabled={!!disabled || !!busy || props.disabled}
				className={(className||'') + ' h_button m-1'}
			>
				{children}
				{/* {props.model?.observers().join(',')} */}
				{text || ''}
				{busy !== undefined && <HBusySpinner style={{ visibility: busy ? 'visible' : 'hidden', marginLeft: '0.1em' }} />}
			</button>
		);
	} else {
		return (
			<button
				{...props}
				//
				ref={ref2 as any}
				// data-model-id={model?.model_id.toString()}
				disabled={!!disabled || !!busy || props.disabled}
				className={className || ''}
			>
				{children}
				{/* {props.model?.observers().join(',')} */}
				{text || ''}
				{busy !== undefined && <HBusySpinner style={{ visibility: busy ? 'visible' : 'hidden', marginLeft: '0.1em' }} />}
			</button>
		);
	}
}


// function Test(model:ReactModel<{type:string, size:string}>){
// 	return <HButton model={model} onModelChange={(state)=>{
// 		state.size
// 	}}>Good</HButton>
// }